import { FC } from "react";

const LoadingState: FC = () => {
    return (
        <div className="flex items-center justify-center py-8">
            <div className="loading-spinner rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
    );
};

export default LoadingState;